import React from 'react';

import { Container, Inner, Name, Side } from './styled';
import { type RotationProps } from './types';

const Rotation = ({
	size,
	highlighted,
	isFirstLastSame,
	name,
	variant,
	children,
}: RotationProps) => {
	return (
		<Container role="none" highlighted={highlighted} size={size} isFirstLastSame={isFirstLastSame}>
			{variant === 'full' && (
				<Side aria-hidden>
					<Name slim={size !== 'large'}>{name}</Name>
				</Side>
			)}
			<Inner role="none">{children}</Inner>
		</Container>
	);
};

export { Rotation };
